<!--
 * @Description: 陪访详情组件
 * @Author: zz
-->
<template>
  <a-form ref="formRef" name="accompanyingVisitBaseMessage" :model="form">
    <dc-layout-card title="主管共同销售信息">
      <dc-form-item
        label="客户名称"
        name="cosId"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]">
        <ClueAndCustomerSelect
          appId="cos_lbu"
          v-model:value="form.cosId"
          v-model:label="form.customerName"
          v-model:record="customerRecord"
          :disabled="route.query.followRefId || route.query.planId ? true : false"
          @change="changeCus"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        name="startTime"
        label="跟进记录"
        :rules="[{ validator: selectForNumberValidate, message: '请选择' }]">
        <CosSelect
          v-model:value="form.startTime"
          :fieldNames="{ label: 'startTime', value: 'id' }"
          :options="followList"
          allowClear
          placeholder="请选择"
          @change="changeFollow"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="客户负责人" name="dutyBy">
        <CosInput
          v-model:value.trim="form.dutyBy"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="创建时间" name="createTime">
        <CosInput
          v-model:value.trim="form.createTime"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="跟进方式" name="followMode">
        <CosInput
          v-model:value.trim="selectedFollow.followMode"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="联系人" name="contactName">
        <CosInput
          v-model:value.trim="selectedFollow.contactName"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="陪访人" name="lbuAccompanyPerson">
        <CosInput
          v-model:value.trim="selectedFollow.lbuAccompanyPerson"
          :maxlength="200"
          :disabled="true"
          placeholder="自动带出"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="下次陪访时间" name="nextVisitTime" :rules="[{ required: true, message: '请选择' }]">
        <CosSingleDateTimePicker
            v-model:startTime="form.nextVisitTime"
            :isRange="false"
            :view="view"
        />
      </dc-form-item>
      <a-col :span="24"></a-col>
      <dc-form-item label="目的" name="lbuPurpose" :span="12">
        <CosTextarea v-model:value.trim="selectedFollow.lbuPurpose" :maxlength="2000" :disabled="true"
                     placeholder="自动带出"
                     :view="view"/>
      </dc-form-item>
      <dc-form-item label="跟进过程" name="process" :span="12">
        <CosTextarea v-model:value.trim="selectedFollow.process" :maxlength="2000" :disabled="true"
                     placeholder="自动带出"
                     :view="view"/>
      </dc-form-item>
      <dc-form-item label="当前遇到的问题" name="problem" :span="12">
        <CosTextarea v-model:value.trim="selectedFollow.problem" :maxlength="2000" :disabled="true"
                     placeholder="自动带出"
                     :view="view"/>
      </dc-form-item>
      <dc-form-item label="后续" name="result" :span="12">
        <CosTextarea v-model:value.trim="selectedFollow.result" :maxlength="2000" :disabled="true"
                     placeholder="自动带出"
                     :view="view"/>
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="陪访信息">
      <dc-form-item label="对销售员的观察" name="process" :rules="[{ required: true, message: '请输入' }]" :span="12">
        <CosTextarea v-model:value="form.process" :maxlength="2000" placeholder="请输入" :view="view"/>
      </dc-form-item>
      <dc-form-item label="对销售员的提升计划" name="followUp" :rules="[{ required: true, message: '请输入' }]" :span="12">
        <CosTextarea v-model:value="form.followUp" :maxlength="2000" placeholder="请输入" :view="view"/>
      </dc-form-item>
      <dc-form-item label="抄送人" name="ccTo">
        <UserSelect permission v-model:value="form.ccTo" mode="multiple" :view="view"/>
      </dc-form-item>
    </dc-layout-card>
  </a-form>
  <cos-footer-button v-model:value="form" :formRef="formRef">
    <a-button type="primary" v-if="props.type === 'add' || props.type === 'edit'" @click="handleSubmit()"
              :loading="loading"
              v-permission="permissionPage.save"
    >保存
    </a-button
    >
  </cos-footer-button>
  <!--  v-if="!disabled"-->
</template>
<script setup lang="ts">
import { watch, ref, PropType, onMounted, computed } from 'vue'
import { AccompanyingVisitDetail } from '@/typings/api/yuntuSales'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import { cloneDeep } from 'lodash-es'
import { useRoute } from 'vue-router'
import { selectForNumberValidate } from '@/utils/validate'
import {
  accompanyingVisitCreate, accompanyingVisitDetail,
  accompanyingVisitUpdate,
  getFollowListByRefId
} from '@/api/yuntuSales/superivisorAccompanyingVisit'
import { fetchUsersByWorkCode, listByParamCodes } from '@/api/common'
import { shareInfo } from '@dc-platform/dc-interaction'
import { paramCodesDataFilter } from '@/utils'
import { DcMessage } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import { FormInstance } from 'ant-design-vue'
import { followRecordsDetail } from '@/api/yuntuSales/followUpManage'
import dayjs from 'dayjs'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'

const route = useRoute()
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  data: {
    type: Object as PropType<AccompanyingVisitDetail>
  },
  view: {
    type: Boolean
  },
  valueFormat: {
    type: String,
    default: 'YYYY/MM/DD'
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'comment', 'view'].includes(value)
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const loading = ref(false)
const customerRecord = ref<any>({})
const resetValue = ref<AccompanyingVisitDetail>({})
const formRef = ref<FormInstance>()
const followList = ref<any[]>([])
const selectedFollow = ref<any>({})
const managerNo = ref<string>()
const emit = defineEmits(['update:detail', 'getDetail'])
const form = ref<AccompanyingVisitDetail>({
  ccTo: [`${managerNo.value}`]
})
const paramCodeData = ref<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
const handleReset = () => {
  console.log(form.value)
  const createTime = form.value.createTime
  form.value = {
    createTime: createTime,
    ccTo: [`${managerNo.value}`]
  }
  followList.value = []
  selectedFollow.value = {}
}
// 校验访客计划表单
const validate = () => {
  Object.values(formRef).forEach((v: any) => {
    if (v) {
      v.validate()
    }
  })
  formRef.value?.validate()
}
watch(
  () => customerRecord.value,
  (val) => {
    if (val.stage === 1) {
      salesClueDetail({ clueId: val.id }).then((res) => {
        const clueDetail = res.data
        if (clueDetail) {
          form.value.dutyBy = clueDetail.followerName
        }
      })
    } else {
      potentialDetail(val.id).then((res) => {
        const customerDetail = res.data
        if (customerDetail && customerDetail.customerInfo != null) {
          form.value.dutyBy = customerDetail.customerInfo.sellerName
        }
      })
    }
  },
  { immediate: true }
)
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
const changeCus = (val: any) => {
  if (val && (props.type === 'add' || props.type === 'edit')) {
    selectedFollow.value = {}
    followList.value = []
    form.value.startTime = ''
    form.value.followId = ''
    fetchFollowList(val)
  }
}
const changeFollow = (v: any) => {
  if (v) {
    selectedFollow.value = followList.value.find((item) => item.id === v)
    selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find((item) => item.id === selectedFollow.value.mode)?.name
    form.value = {
      ...form.value,
      followId: selectedFollow.value.id,
      startTime: selectedFollow.value.startTime
    }
  } else {
    selectedFollow.value = {}
    form.value = {
      ...form.value,
      followId: undefined,
      startTime: undefined
    }
  }
}
const handleMentorChange = () => {
  if (props.type === 'add') getFollowerInfo(shareInfo.getUserInfo().work_code)
}

const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    // if (followerInfo && followerInfo.lbuCustomerRegion != null) {
    //   form.value.mentorRegion = followerInfo.lbuCustomerRegion
    // } else {
    //   form.value.mentorRegion = undefined
    //   setTimeout(() => formRef.value?.clearValidate('mentorRegion'))
    // }

    if (followerInfo && followerInfo.managerNo != null) {
      managerNo.value = followerInfo.managerNo
      form.value.ccTo = [`${followerInfo.managerNo}`]
    }
  })
}
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    accompanyingVisitDetail({ id: route.query.id })
      .then((res) => {
        form.value = res.data ? res.data : {}
        // emit('update:detail', res.data)
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
        fetchFollowList(form.value.cosId)
        if (form.value.followId) {
          fetchFollowDetail(form.value.followId)
        }
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取跟进记录列表
const fetchFollowList = async (refId: any) => {
  getFollowListByRefId(refId).then((res) => {
    followList.value = res.data
  })
}
// 获取跟进记录详情
const fetchFollowDetail = async (id: any) => {
  followRecordsDetail(id)
    .then((res) => {
      const followDetail = res.data
      if (followDetail) {
        selectedFollow.value = followDetail
        selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find((item) => item.id === selectedFollow.value.mode)?.name
      }
    })
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
onMounted(() => {
  handleMentorChange()
  getByParamCodes()
  if (props.type === 'add') {
    const now = dayjs()
    form.value.createTime = now.format(`${props.valueFormat} HH:mm:ss`)
  }
  fetch()
})

const permissionPage = computed(() => {
  if (props.type === 'add') {
    return { save: 'lbu_accompanying_visit_add' }
  } else if (props.type === 'edit') {
    return { save: 'lbu_accompanying_visit_edit_btn' }
  } else {
    return {}
  }
})
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...form.value
    }
    try {
      if (props.type === 'edit') {
        await accompanyingVisitUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await accompanyingVisitCreate(p)
        DcMessage.success('新增成功')
      }
      goBack()
    } catch (error) {
    }
    loading.value = false
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSupervisorAccompanyingVisitBaseMessage' }
</script>
<style lang="scss"></style>
